import { render, staticRenderFns } from "./ClipboardDirective.vue?vue&type=template&id=2fd7a961&"
import script from "./ClipboardDirective.vue?vue&type=script&lang=js&"
export * from "./ClipboardDirective.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports